import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Modal } from 'nallian-shared-ui/lib/components';
import { CardFlex } from 'nallian-shared-ui/lib/layout/UserApps';
import AppIcon from './AppIcon';

const AppIconWrapper = styled(CardFlex)`
  margin: 0;
  width: auto;
`;

const AppsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 0.5rem;
  justify-items: center;
`;

const ViewMoreAppsModal = ({ open, onClose, community, apps }) => {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <Modal open closeIcon onClose={onClose} size="small">
      <Modal.Header>
        {t('allApplications')} - {community?.name}
      </Modal.Header>
      <Modal.Content>
        <AppsGrid>
          {apps?.map(app => (
            <AppIconWrapper
              big
              direction="column"
              alignItems="center"
              key={`${community?.id}_${app.appTag}`}
            >
              <AppIcon app={app} />
            </AppIconWrapper>
          ))}
        </AppsGrid>
      </Modal.Content>
    </Modal>
  );
};

ViewMoreAppsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  community: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  apps: PropTypes.array,
};

ViewMoreAppsModal.defaultProps = {
  community: null,
  apps: [],
};

export default ViewMoreAppsModal;
